"use strict";

module.exports = require("./DragDrop.js");